import PropTypes from 'prop-types';

export const BtnPausarSeller = ({ estado, inCreate, setEstado, isAdminMod, isCategory }) => {
    if ((estado === "pausado" || inCreate) && (!isAdminMod && !isCategory)) {
        return null;
    }

    if (!isCategory && !isAdminMod) {
        return (
            <button
                disabled={estado === "pausado" || inCreate}
                onClick={setEstado}
                name="pausado"
                hidden={estado === "en_revision" || estado === "pendiente_activacion"}
                className="btn background-rojo-megatone waves-effect waves-light btn-sm m-r-10"
            >
                Pausar
            </button>
        )
    }

    return null;
}
BtnPausarSeller.propTypes = {
    estado: PropTypes.string,
    inCreate: PropTypes.bool,
    setEstado: PropTypes.func,
    isAdminMod: PropTypes.bool,
    isCategory: PropTypes.bool,
}